//import React, {useState} from 'react'
import './App.css';
import './normalize.css';
//import Navbar from './components/Navbar.js';
// import AnimationIni from './components/AnimationIni.js';
// import Main from './components/Main.js';
// import Footer from './components/Footer.js';
import Home from './components/Home.js';
import Matricula from './components/pages/Matricula.js';
import {
  useRoutes
} from 'react-router-dom';

function App() {
  let element = useRoutes([
    {path: '/', element: <Home/>},
    {path: '/matricula', element: <Matricula/>},
  ]);

  return element;
}


// function App() {
  
//   return (
//     <div className="App">

//       <AnimationIni/>
//       <Main/>
//       <Footer/>

//       {/*<header className="App-header">
//         <Navbar/>
//       </header>*/}

//     </div>
//   );
// }

export default App;
